import React from "react";
import fp from "lodash/fp";
import { Row, Col } from "react-bootstrap";

import { TextWithLoader } from "components";
import { LineDivider } from "components/layout";
import { getEntityTypeName } from "mappers";
import { SecondarySplitInfoProps } from "types";

import styles from "../commissionSplits.module.scss";

const SecondarySplitInfo = ({
	isLoading,
	indexArray,
	initialValues,
	secondarySplitInformation,
}: SecondarySplitInfoProps) => {
	const { splitPercent, agent } = initialValues ?? {};

	return (
		<div
			data-autotest="viewSecondarySplitInformationSection"
			className="mb-3"
		>
			<div>
				<h1 className={styles.header}>Secondary Split Information</h1>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Agent:"
							value={agent?.name}
							loading={isLoading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Commission Split:"
							value={
								fp.isNumber(splitPercent)
									? `${splitPercent}%`
									: ""
							}
							loading={isLoading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Entity Type:"
							value={getEntityTypeName(agent?.entityType)}
							loading={isLoading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Partner Type:"
							value={agent?.partnerTypeDisplayName}
							loading={isLoading}
						/>
					</Col>
				</Row>
			</div>
			{secondarySplitInformation?.length - 1 !== indexArray && (
				<LineDivider />
			)}
		</div>
	);
};

export default SecondarySplitInfo;
